import React, { useCallback, useEffect, useRef, useState } from 'react';
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { useLocation, useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  DisplayNavContent,
  DisplayNavWrap,
  FilterSelect,
  ImportUserModal,
  MenuBarWrap,
  NavBarButtonWrap,
  SearchBar,
  TabBar,
} from './display.style';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { ReactComponent as UserIcon } from 'assets/images/SVG/icons/user-icon.svg';
import { ReactComponent as GroupIcon } from 'assets/images/SVG/icons/group-header-icon.svg';
import { ReactComponent as OuIcon } from 'assets/images/SVG/icons/ou-icon.svg';
import { ReactComponent as DeleteIcon } from 'assets/images/SVG/icons/delete-icon.svg';
import { ReactComponent as KeyIcon } from 'assets/images/SVG/icons/key-icon.svg';
import { ReactComponent as TickIcon } from 'assets/images/SVG/icons/tick-icon.svg';
import { ReactComponent as CancelIcon } from 'assets/images/SVG/icons/cancel-icon.svg';
import { ReactComponent as UnlockIcon } from 'assets/images/SVG/icons/unlock-icon.svg';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import ImportUser from 'component/create_user_component/import_user';
import _ from 'lodash';
import {
  deleteGroupData,
  getExportGroups,
  getOuGroupData,
  resetGroups,
  setGroupSearch,
  setGroupSelectedItems,
  setPageGroupNumber,
} from 'redux/slices/getOuGroups';
import { getChildOuData, getExportOus, resetOus, setOuSearch, setPageOuNumber } from 'redux/slices/getChildOu';
import {
  UnLockUser,
  bulkDisable,
  bulkEnable,
  deleteUserData,
  getAllUsers,
  getExportUsers,
  setSelectedItems,
} from 'redux/slices/userSlice';
import { Dropdown, Form, Modal, Select, Tooltip, message } from 'antd';
import { resetUsers, setPageNumber, setSearchQuery, setUsersFilter } from 'redux/slices/selectedNodeSlice';
import { ReactComponent as ExportIcon } from 'assets/images/SVG/icons/export-icon.svg';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import Swal from 'sweetalert2';
import { useRefreshGroupTab } from 'component/table_component/groupData/refreshGroupData';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';
import BulkResetPassword from 'component/modal_components/bulk_reset';
import { refreshToken } from 'redux/slices/authSlice';
import BulkUpdateUser from 'component/modal_components/edit/bulk_update';
import BulkCreateUsers from 'component/modal_components/bulk_create';

function getGroupType(value) {
  switch (value) {
    case 1:
      return 'Security';
    case 2:
      return 'Distribution';
    default:
      return 'Security';
  }
}
function getGroupScope(value) {
  switch (value) {
    case 1:
      return 'Domain Local';
    case 2:
      return 'Global';
    case 3:
      return 'Universal';
    default:
      return 'BuiltIn Local';
  }
}

export default function DisplayNavBar() {
  const searchRef = useRef(null);
  const refreshUserTab = useRefreshUserTab();
  const refreshGroupTab = useRefreshGroupTab();
  const [loading, setLoading] = useState(false);
  const [loadExportInfo, setLoadExportInfo] = useState(false);
  const [bulkResetModal, setBulkResetModal] = useState(false);
  const [bulkUpdateModal, setBulkUpdateModal] = useState(false);
  const [bulkCreateModal, setBulkCreateModal] = useState(false);
  const { domainExportAttributeData } = useSelector((state) => state.settings);
  const { selectedItems, selectedItemsValues } = useSelector((state) => state.getUsers);
  const selectedNode = useSelector((state) => state.selectedNode);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const { pageGroupSize, groupSearch, groupIsDescending, groupSortType, groupSelectedItems } = useSelector(
    (state) => state.getOuGroupData
  );
  const { pageOuSize, ouSearch, ouIsDescending, ouSortType } = useSelector((state) => state.getChildOuData);
  const {
    ouAdminRights,
    portalAdminRights,
    mailUnlockUser,
    mailEnableUser,
    mailDisableUser,
    overrideGlobalStatus,
    domainMailUnlockUser,
    domainMailDisableUser,
    domainMailEnableUser,
  } = useSelector((state) => state.settings);
  const [activeMenuItem, setActiveMenuItem] = useState('1');
  const [importData, setimportData] = useState([]);
  const [fileName, setFileName] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const role = localStorage.getItem('role');
  const isSuperAdmin = role === 'superadmin';
  const canUserEdit =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserEdit ?? true : ouAdminRights?.ouAdminuserEdit ?? true);
  const canCreateUser =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserCreate ?? true : ouAdminRights?.ouAdminuserCreate ?? true);
  const canCreateGroup =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portalgroupCreate ?? true : ouAdminRights?.ouAdmingroupCreate ?? true);
  const canCreateOu =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portalouCreate ?? true : ouAdminRights?.ouAdminouCreate ?? true);
  const canImportUser =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portaluserCreateBulkUsers ?? true
      : ouAdminRights?.ouAdminuserCreateBulkUsers ?? true);
  const canBulkUserAction =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portaluserBulkAction ?? true
      : ouAdminRights?.ouAdminuserBulkAction ?? true);
  const canExportUser =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserExport ?? true : ouAdminRights?.ouAdminuserExport ?? true);
  const canUserDelete =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserDelete ?? true : ouAdminRights?.ouAdminuserDelete ?? true);
  const canGroupDelete =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portalgroupDelete ?? true : ouAdminRights?.ouAdmingroupDelete ?? true);
  const canBulkGroupAction =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portalgroupBulkAction ?? true
      : ouAdminRights?.ouAdmingroupBulkAction ?? true);
  const canExportGroup =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portalgroupExport ?? true : ouAdminRights?.ouAdmingroupExport ?? true);
  const canResetPassword =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portaluserResetPassword ?? true
      : ouAdminRights?.ouAdminuserResetPassword ?? true);
  const canUnlock =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserUnlock ?? true : ouAdminRights?.ouAdminuserUnlock ?? true);
  const canEnableDisable =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portaluserEnableDisable ?? true
      : ouAdminRights?.ouAdminuserEnableDisable ?? true);
  const canExportOu =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portalouExport ?? true : ouAdminRights?.ouAdminouExport ?? true);
  const canUnlockNotify = overrideGlobalStatus?.settings ? domainMailUnlockUser ?? true : mailUnlockUser ?? true;
  const canDisableNotify = overrideGlobalStatus?.settings ? domainMailDisableUser ?? true : mailDisableUser ?? true;
  const canEnableNotify = overrideGlobalStatus?.settings ? domainMailEnableUser ?? true : mailEnableUser ?? true;

  const searchQuery = (value) => {
    const ouName =
      selectedNode.selectedNode?.dnName ||
      (localStorage.getItem('role') === 'ouadmin' ? adminOuName.dnName : localStorage.getItem('domainDn'));
    const fqdn = selectedNode.domainName || localStorage.getItem('domain');
    const page = 1;
    const searchQuery = value;

    let commonValues = { ouName, fqdn, page, searchQuery };

    if (location.pathname === '/') {
      let extraValues = {
        pageSize: selectedNode.pageSize,
        isDescending: selectedNode.isDescending,
        sortType: selectedNode.sortType,
        usersFilter: selectedNode.usersFilter,
      };
      let combinedValues = { ...commonValues, ...extraValues };
      dispatch(getAllUsers(combinedValues));
      dispatch(setPageNumber(1));
      dispatch(setSearchQuery(value));
    } else if (location.pathname === '/groupdata') {
      let extraValues = {
        pageSize: pageGroupSize,
        isDescending: groupIsDescending,
        sortType: groupSortType,
      };
      let combinedValues = { ...commonValues, ...extraValues };
      dispatch(getOuGroupData(combinedValues));
      dispatch(setPageGroupNumber(1));
      dispatch(setGroupSearch(value));
    } else if (location.pathname === '/oudata') {
      let extraValues = {
        pageSize: pageOuSize,
        isDescending: ouIsDescending,
        sortType: ouSortType,
      };
      let combinedValues = { ...commonValues, ...extraValues };
      dispatch(getChildOuData(combinedValues));
      dispatch(setPageOuNumber(1));
      dispatch(setOuSearch(value));
    }
  };

  const handleSearch = useCallback(_.debounce(searchQuery, 300), [searchQuery]);

  useEffect(() => {
    // Update the active menu item based on the current route
    if (location.pathname === '/') {
      dispatch(setGroupSelectedItems([]));
      setActiveMenuItem('1');
    } /* currently computer data is no required may include in future
     else if (location.pathname === '/computerdata') {
      setActiveMenuItem('computers');
    }  */ else if (location.pathname === '/groupdata') {
      dispatch(setSelectedItems([]));
      setActiveMenuItem('2');
    } else if (location.pathname === '/oudata') {
      setActiveMenuItem('3');
    }
  }, [location.pathname]);

  const getButtonName = () => {
    // Change button name based on route
    if (location.pathname === '/') {
      return 'Create User';
    } else if (location.pathname === '/groupdata') {
      return 'Create Group';
    } else if (location.pathname === '/oudata') {
      return 'Create OU';
    }
  };

  const handleFilterChange = (value) => {
    let values = {
      ouName:
        selectedNode.selectedNode?.dnName ||
        (localStorage.getItem('role') === 'ouadmin' ? adminOuName.dnName : localStorage.getItem('domainDn')),
      fqdn: selectedNode.domainName || localStorage.getItem('domain'),
      page: 1,
      pageSize: selectedNode.pageSize,
      isDescending: selectedNode.isDescending,
      sortType: selectedNode.sortType,
      searchQuery: selectedNode.searchQuery,
      usersFilter: value,
    };
    dispatch(getAllUsers(values));
    dispatch(setUsersFilter(value));
    dispatch(setPageNumber(1));
  };

  const handleExportClick = async () => {
    const ouName =
      selectedNode.selectedNode?.dnName ||
      (localStorage.getItem('role') === 'ouadmin' ? adminOuName.dnName : localStorage.getItem('domainDn'));
    const fqdn = selectedNode.domainName || localStorage.getItem('domain');

    let commonValues = { ouName, fqdn };
    if (location.pathname === '/') {
      setLoadExportInfo(true);
      let extraValues = {
        searchQuery: selectedNode.searchQuery || '',
        usersFilter: selectedNode.usersFilter || 'all',
      };
      let combinedValues = { ...commonValues, ...extraValues };
      try {
        setLoading(true);
        const exportUsersData = await dispatch(getExportUsers(combinedValues));
        if (exportUsersData.payload.userList.length === 0) {
          message.info('Export data is Empty. No export will be performed.');
        } else {
          const excelData = new Excel.Workbook();
          const excelSheet = excelData.addWorksheet('New Sheet');
          const columns = domainExportAttributeData.map((attr) => ({
            [attr]: attr,
          }));
          excelSheet.columns = columns.map((column) => ({
            header: Object.keys(column)[0],
            width: 30,
          }));
          excelSheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
          });
          exportUsersData.payload.userList.forEach((row) => {
            const rowData = columns.map((column) => {
              const columnName = Object.values(column)[0];
              let value = row[columnName];
              if (columnName === 'Associated Groups' && Array.isArray(value)) {
                value = value.join(', ');
              }
              return value;
            });
            excelSheet.addRow(rowData);
          });

          const buffer = await excelData.xlsx.writeBuffer();
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, 'ADWeb-Users-Records.xlsx');
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoading(false);
        setLoadExportInfo(false);
      }
    } else if (location.pathname === '/groupdata') {
      let extraValues = {
        searchQuery: groupSearch || '',
      };
      let combinedValues = { ...commonValues, ...extraValues };
      try {
        setLoading(true);
        const exportGroupsData = await dispatch(getExportGroups(combinedValues));
        if (exportGroupsData.payload.groupList.length === 0) {
          message.info('Export data is Empty. No export will be performed.');
        } else {
          const excelData = new Excel.Workbook();
          const excelSheet = excelData.addWorksheet('New Sheet');
          const columns = [
            { 'Group Name': 'groupName' },
            { 'Group Name (Pre Windows10)': 'namePreWin' },
            { Email: 'email' },
            { 'Group Type': 'groupType' },
            { Description: 'description' },
            { 'Group Scope': 'groupScope' },
            { 'OU Name': 'ouName' },
            { 'Group Members': 'groupMembers' },
            { 'Members Of': 'membersOf' },
          ];
          excelSheet.columns = columns.map((column) => ({
            header: Object.keys(column)[0],
            width: 30,
          }));
          excelSheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
          });
          exportGroupsData.payload.groupList.forEach((row) => {
            const rowData = columns.map((column) => {
              const columnName = Object.values(column)[0];
              let value = row[columnName];
              if (columnName === 'groupMembers' && Array.isArray(value)) {
                value = value.map((member) => member.name).join(', ');
              } else if (columnName === 'membersOf' && Array.isArray(value)) {
                value = value.join(', ');
              } else if (columnName === 'groupType') {
                value = getGroupType(value);
              } else if (columnName === 'groupScope') {
                value = getGroupScope(value);
              }
              return value;
            });
            excelSheet.addRow(rowData);
          });

          const buffer = await excelData.xlsx.writeBuffer();
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, 'ADWeb-Groups-Records.xlsx');
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoading(false);
        setLoadExportInfo(false);
      }
    } else if (location.pathname === '/oudata') {
      let extraValues = {
        searchQuery: ouSearch || '',
      };
      let combinedValues = { ...commonValues, ...extraValues };
      try {
        setLoading(true);
        const exportOusData = await dispatch(getExportOus(combinedValues));
        if (exportOusData.payload.ouList.length === 0) {
          message.info('Export data is Empty. No export will be performed.');
        } else {
          const excelData = new Excel.Workbook();
          const excelSheet = excelData.addWorksheet('New Sheet');
          const columns = [
            { 'OU Name': 'name' },
            { Description: 'description' },
            { 'Protect From Accidental Deletion': 'accidentialDeletion' },
          ];
          excelSheet.columns = columns.map((column) => ({
            header: Object.keys(column)[0],
            width: 30,
          }));
          excelSheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
          });
          exportOusData.payload.ouList.forEach((row) => {
            const rowData = columns.map((column) => {
              const columnName = Object.values(column)[0];
              let value = row[columnName];
              return value;
            });
            excelSheet.addRow(rowData);
          });

          const buffer = await excelData.xlsx.writeBuffer();
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, 'ADWeb-Ous-Records.xlsx');
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoading(false);
        setLoadExportInfo(false);
      }
    }
  };

  const handleButtonClick = () => {
    // Button click based on the current route
    if (location.pathname === '/') {
      navigate('/create_user');
    } else if (location.pathname === '/oudata') {
      if (selectedNode.typeOfData === 'domain' || selectedNode.typeOfData === null) {
        navigate('/create_parent_ou');
      } else {
        navigate('/create_ou');
      }
    } /* currently computer data is no required may include in future
     else if (location.pathname === '/computerdata') {
      navigate('/computerdata');
    }  */ else if (location.pathname === '/groupdata') {
      navigate('/create_group');
    }
    dispatch(resetUsers());
    dispatch(resetGroups());
    dispatch(resetOus());
  };

  useEffect(() => {
    // Check if selectedNode.typeOfData is 'container' and navigate to '/'
    if (selectedNode.typeOfData === 'container' && location.pathname === '/oudata') {
      navigate('/');
    }
  }, [location.pathname, selectedNode.typeOfData, navigate]);

  /*  currently computer data is no required may include in future
  const getComputers = () => {
    navigate('computerdata');
  }; */

  const shouldShowCreateButton = () => {
    if (location.pathname === '/' && canCreateUser) {
      return true;
    } else if (location.pathname === '/groupdata' && canCreateGroup) {
      return true;
    } else if (location.pathname === '/oudata' && canCreateOu) {
      return true;
    }
    return false;
  };
  const shouldShowExportButton = () => {
    if (location.pathname === '/' && canExportUser) {
      return true;
    } else if (location.pathname === '/groupdata' && canExportGroup) {
      return true;
    } else if (location.pathname === '/oudata' && canExportOu) {
      return true;
    }
    return false;
  };
  const shouldShowBulkActionButton = () => {
    if (location.pathname === '/' && canBulkUserAction) {
      return true;
    } else if (location.pathname === '/groupdata' && canBulkGroupAction) {
      return true;
    }
    return false;
  };

  const items = [
    {
      label: 'Users',
      key: '1',
      icon: <UserIcon className='af-display-navbar-usericon' />,
    },
    /*  currently computer data is no required may include in future
    {
      label: 'Computers',
      key: 'computers',
      icon: <ComputerIcon />,
      onClick: getComputers,
    }, */
    {
      label: 'Groups',
      key: '2',
      icon: <GroupIcon className='af-display-navbar-groupicon' />,
    },
    selectedNode.typeOfData === 'container' || selectedNode.typeOfData === 'builtinDomain'
      ? 'ou'
      : {
          label: 'OUs',
          key: '3',
          icon: <OuIcon className='af-display-navbar-ouicon' />,
        },
  ];

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.resetFields();
    }
    dispatch(resetUsers());
    dispatch(resetGroups());
    dispatch(resetOus());
  }, [selectedNode.selectedNode]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
    dispatch(refreshToken());
  };

  const handleCancel = () => {
    setimportData([]);
    setFileName('');
    setIsModalOpen(false);
  };
  const handleTabClick = (key) => {
    setActiveMenuItem(key);
    if (searchRef.current) {
      searchRef.current.resetFields();
    }
    dispatch(resetUsers());
    dispatch(resetGroups());
    dispatch(resetOus());
    switch (key) {
      case '1':
        navigate('/');
        break;
      case '2':
        navigate('/groupdata');
        break;
      case '3':
        navigate('/oudata');
        break;
      default:
        break;
    }
  };

  const handleBulkDelete = async () => {
    if (selectedItems.length === 0 && groupSelectedItems.length === 0) {
      SweetSweetAlert({
        sweetData: 'There are no objects selected to perform this action.',
        icon: 'info',
        buttonColor: 'blue',
      });
    } else {
      const result = await Swal.fire({
        icon: 'warning',
        title: `Are you sure you want to delete the selected ${location.pathname === '/' ? 'user(s)' : 'group(s)'}?`,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        width: '400px',
        heightAuto: false,
        showCancelButton: true,
        cancelButtonColor: 'green',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
          container: 'custom-swal-container',
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
      });

      if (result.isConfirmed) {
        try {
          setLoading(true);
          let response;
          if (location.pathname === '/') {
            let values = {
              fqdn: selectedNode.domainName,
              dn: selectedItems,
            };
            response = await dispatch(deleteUserData(values));
          } else {
            let values = {
              fqdn: selectedNode.domainName,
              dn: groupSelectedItems,
            };
            response = await dispatch(deleteGroupData(values));
          }
          if (response?.payload.status === 200) {
            await SweetSweetAlert({
              sweetData: `The Selected ${
                location.pathname === '/'
                  ? selectedItems.length === 1
                    ? 'User'
                    : 'Users'
                  : groupSelectedItems.length === 1
                  ? 'Group'
                  : 'Groups'
              } have been deleted successfully.`,
              icon: 'success',
              buttonColor: 'green',
            });
          } else {
            await SweetSweetAlert({
              text: 'Something Wrong Please try again.!!',
              icon: 'error',
              buttonColor: 'red',
            });
          }
        } catch (error) {
          await SweetSweetAlert({
            text: 'Something Wrong Please try again.!!',
            icon: 'error',
            buttonColor: 'red',
          });
        } finally {
          setLoading(false);
          location.pathname === '/' ? dispatch(setSelectedItems([])) : dispatch(setGroupSelectedItems([]));
        }
        location.pathname === '/' ? refreshUserTab() : refreshGroupTab();
      }
    }
  };

  const handleBulkReset = async () => {
    if (selectedItems.length === 0) {
      SweetSweetAlert({
        sweetData: 'There are no objects selected to perform this action.',
        icon: 'info',
        buttonColor: 'blue',
      });
    } else {
      setBulkResetModal(true);
    }
  };

  const handleBulkEnable = async () => {
    if (selectedItems.length === 0) {
      SweetSweetAlert({
        sweetData: 'There are no objects selected to perform this action.',
        icon: 'info',
        buttonColor: 'blue',
      });
    } else {
      let htmlContent = `
      <div class='af-display-navbar-bulkenable-wrap' style="display: flex; align-items: center; justify-content: center;">
        <input class='af-display-navbar-bulkenable-input' type="checkbox" id="notifyByEmail" style="width: 30px; height: 20px;">
        <label class='af-display-navbar-bulkenable-label' for="notifyByEmail">Notify by email</label>
      </div>
    `;

      const result = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to enable selected user(s)?',
        html: htmlContent,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        width: '400px',
        showCancelButton: true,
        cancelButtonColor: 'green',
        confirmButtonText: 'Enable',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
          container: 'custom-swal-container',
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
        didRender: () => {
          const notifyEmailEnable = document.getElementById('notifyByEmail');
          notifyEmailEnable.checked = canEnableNotify;
        },
        preConfirm: () => {
          return {
            notifyByEmail: document.getElementById('notifyByEmail').checked,
          };
        },
      });
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const enableUsers = selectedItemsValues.map((enable) => ({
            userName: enable.dn,
            fqdn: selectedNode.domainName,
            notifyEmail: result.value.notifyByEmail,
            domainId: selectedNode.currentdomainId,
          }));
          const response = await dispatch(bulkEnable(enableUsers));
          if (response?.payload.status === 200) {
            await SweetSweetAlert({
              sweetData: `The selected ${selectedItems.length === 1 ? 'user' : 'users'} have been enabled.`,
              icon: 'success',
              buttonColor: 'green',
            });
          } else {
            await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
          }
        } catch (error) {
          await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        } finally {
          setLoading(false);
          dispatch(setSelectedItems([]));
          await refreshUserTab();
        }
      }
    }
  };

  const handleBulkDisable = async () => {
    if (selectedItems.length === 0) {
      SweetSweetAlert({
        sweetData: 'There are no objects selected to perform this action.',
        icon: 'info',
        buttonColor: 'blue',
      });
    } else {
      let htmlContent = `
      <div class='af-display-navbar-bulkdisable-wrap' style="display: flex; align-items: center; justify-content: center;">
        <input class='af-display-navbar-bulkdisable-input' type="checkbox" id="notifyByEmail" style="width: 30px; height: 20px;">
        <label class='af-display-navbar-bulkdisable-label' for="notifyByEmail">Notify by email</label>
      </div>
    `;

      const result = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to disable selected user(s)?',
        html: htmlContent,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        width: '400px',
        showCancelButton: true,
        cancelButtonColor: 'green',
        confirmButtonText: 'Disable',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
          container: 'custom-swal-container',
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
        didRender: () => {
          const notifyEmailDisable = document.getElementById('notifyByEmail');
          notifyEmailDisable.checked = canDisableNotify;
        },
        preConfirm: () => {
          return {
            notifyByEmail: document.getElementById('notifyByEmail').checked,
          };
        },
      });
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const disableUsers = selectedItemsValues.map((disable) => ({
            userName: disable.dn,
            fqdn: selectedNode.domainName,
            notifyEmail: result.value.notifyByEmail,
            domainId: selectedNode.currentdomainId,
          }));
          const response = await dispatch(bulkDisable(disableUsers));
          if (response?.payload.status === 200) {
            await SweetSweetAlert({
              sweetData: `The selected ${selectedItems.length === 1 ? 'user' : 'users'} have been disabled.`,
              icon: 'success',
              buttonColor: 'green',
            });
          } else {
            await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
          }
        } catch (error) {
          await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        } finally {
          setLoading(false);
          dispatch(setSelectedItems([]));
          await refreshUserTab();
        }
      }
    }
  };

  const handleBulkUnlock = async () => {
    if (selectedItems.length === 0) {
      SweetSweetAlert({
        sweetData: 'There are no objects selected to perform this action.',
        icon: 'info',
        buttonColor: 'blue',
      });
    } else {
      const htmlContent = `
      <div class='af-display-navbar-bulkunlock-wrap' style="display: flex; align-items: center; justify-content: center;">
        <input class='af-display-navbar-bulkunlock-input' type="checkbox" id="notifyByEmail" style=" width: 30px; height: 20px;">
        <label class='af-display-navbar-bulkunlock-label' for="notifyByEmail">Notify by email</label>
      </div>
      `;
      const result = await Swal.fire({
        icon: 'warning',
        title: `Are you sure you want to unLock selected user(s)?`,
        html: htmlContent,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        width: '400px',
        showCancelButton: true,
        cancelButtonColor: 'green',
        confirmButtonText: 'UnLock',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
          container: 'custom-swal-container',
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
        didRender: () => {
          const notifyEmailUnlock = document.getElementById('notifyByEmail');
          notifyEmailUnlock.checked = canUnlockNotify;
        },
        preConfirm: () => {
          return {
            notifyByEmail: document.getElementById('notifyByEmail').checked,
          };
        },
      });
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const unLockUsers = selectedItemsValues.map((value) => ({
            userName: value.dn,
            fqdn: selectedNode.domainName,
            notifyEmail: result.value.notifyByEmail,
            domainId: selectedNode.currentdomainId,
          }));
          const sweetAlert = await dispatch(UnLockUser(unLockUsers));
          if (sweetAlert?.payload.status === 200) {
            await SweetSweetAlert({
              sweetData: `The selected ${selectedItems.length === 1 ? 'user' : 'users'} have been unlocked.`,
              icon: 'success',
              buttonColor: 'green',
            });
          } else {
            SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
          }
        } catch (error) {
          await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        } finally {
          setLoading(false);
          dispatch(setSelectedItems([]));
          await refreshUserTab();
        }
      }
    }
  };

  const handleBulkUpdate = async () => {
    if (selectedItems.length === 0) {
      SweetSweetAlert({
        sweetData: 'There are no objects selected to perform this action.',
        icon: 'info',
        buttonColor: 'blue',
      });
    } else {
      setBulkUpdateModal(true);
    }
  };
  const handleBulkCreate = async () => {
    setBulkCreateModal(true);
  };

  const menuItems = [
    ((location.pathname === '/' && canUserDelete) || (location.pathname === '/groupdata' && canGroupDelete)) && {
      label: (
        <div
          className='af-display-navbar-bulk-delete-label-wrap'
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={handleBulkDelete}
        >
          <DeleteIcon className='af-display-navbar-bulk-delete-icon' />
          <span className='af-display-navbar-bulk-delete-label' style={{ fontSize: '14px', marginLeft: '10px' }}>
            Delete
          </span>
        </div>
      ),
      key: 'bulkDelete',
    },
    ...(location.pathname === '/'
      ? [
          canResetPassword && {
            label: (
              <div
                className='af-display-navbar-bulk-reset-label-wrap'
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleBulkReset}
              >
                <KeyIcon className='af-display-navbar-bulk-reset-icon' />
                <span className='af-display-navbar-bulk-reset-label' style={{ fontSize: '14px', marginLeft: '7px' }}>
                  Reset Password
                </span>
              </div>
            ),
            key: 'bulkPasswordReset',
          },
          canEnableDisable && {
            label: (
              <div
                className='af-display-navbar-bulk-enable-label-wrap'
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleBulkEnable}
              >
                <TickIcon className='af-display-navbar-bulk-enable-icon' />
                <span className='af-display-navbar-bulk-enable-label' style={{ fontSize: '14px', marginLeft: '5px' }}>
                  Enable
                </span>
              </div>
            ),
            key: 'bulkEnable',
          },
          canEnableDisable && {
            label: (
              <div
                className='af-display-navbar-bulk-disable-label-wrap'
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleBulkDisable}
              >
                <CancelIcon className='af-display-navbar-bulk-disable-icon' />
                <span className='af-display-navbar-bulk-disable-label' style={{ fontSize: '14px', marginLeft: '10px' }}>
                  Disable
                </span>
              </div>
            ),
            key: 'bulkDisable',
          },
          canUnlock && {
            label: (
              <div
                className='af-display-navbar-bulk-unlock-label-wrap'
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleBulkUnlock}
              >
                <UnlockIcon className='af-display-navbar-bulk-unlock-icon' />
                <span className='af-display-navbar-bulk-unlock-label' style={{ fontSize: '14px', marginLeft: '10px' }}>
                  Unlock
                </span>
              </div>
            ),
            key: 'bulkUnlock',
          },
          canUserEdit && {
            label: (
              <div
                className='af-display-navbar-bulk-updateuser-label-wrap'
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleBulkUpdate}
              >
                <EditIcon className='af-display-navbar-bulk-updateuser-icon' />
                <span
                  className='af-display-navbar-bulk-updateuser-label'
                  style={{ fontSize: '14px', marginLeft: '7px' }}
                >
                  Update User Attribute
                </span>
              </div>
            ),
            key: 'bulkUpdateUser',
          },
          canCreateUser && {
            label: (
              <div
                className='af-display-navbar-bulk-createuser-label-wrap'
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={handleBulkCreate}
              >
                <UserIcon className='af-display-navbar-bulk-createuser-icon' />
                <span
                  className='af-display-navbar-bulk-createuser-label'
                  style={{ fontSize: '14px', marginLeft: '7px' }}
                >
                  Create Users
                </span>
              </div>
            ),
            key: 'bulkCreateuser',
          },
        ]
      : []),
  ];

  return (
    <DisplayNavWrap className='af-display-navbar-wrap'>
      {loading && <ModalOpenLoader loadExportInfo={loadExportInfo} />}
      <DisplayNavContent className='af-display-navbar-content-wrap'>
        <MenuBarWrap className='af-display-navbar-menu-wrap'>
          <TabBar
            activeKey={activeMenuItem}
            onTabClick={handleTabClick}
            animated={{ inkBar: true }}
            className='af-display-navbar-tab-wrap'
          >
            {items.map((item) => (
              <TabBar.TabPane
                key={item.key}
                tab={
                  <>
                    <span style={{ marginRight: '10px' }} className='af-display-navbar-tab-item-icon'>
                      {item.icon}
                    </span>
                    <span className='af-display-navbar-tab-item-label'>{item.label}</span>
                  </>
                }
                className='af-display-navbar-tab-items'
              />
            ))}
          </TabBar>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Form ref={searchRef} style={{ top: '12px' }} className='af-display-navbar-form-element'>
              <Form.Item name='searchBar' className='af-display-navbar-form-item-search'>
                <SearchBar
                  suffix={<SearchOutlined className='af-display-navbar-search-bar-icon' />}
                  placeholder='Search...'
                  onChange={(e) => {
                    handleSearch(e.target.value);
                  }}
                  className='af-display-navbar-search-bar'
                />
              </Form.Item>
            </Form>
            {location.pathname === '/' && (
              <FilterSelect value={selectedNode.usersFilter} onChange={handleFilterChange}>
                <Select.Option value='all'>All Users</Select.Option>
                <Select.Option value='enabled'>Enabled Users</Select.Option>
                <Select.Option value='disabled'>Disabled Users</Select.Option>
                <Select.Option value='unlocked'>UnLocked Users</Select.Option>
                <Select.Option value='locked'>Locked Users</Select.Option>
              </FilterSelect>
            )}
          </div>
        </MenuBarWrap>

        <NavBarButtonWrap className='af-display-navbar-button-wrap'>
          {location.pathname !== '/computerdata' && shouldShowCreateButton() && (
            <StyledButton
              type='primary'
              onClick={handleButtonClick}
              className='create-button af-display-navbar-create-button'
            >
              {getButtonName()}
            </StyledButton>
          )}

          {location.pathname === '/' && canImportUser && (
            <StyledButton type='primary' onClick={showModal} className='create-button af-display-navbar-import-button'>
              {'Import Users'}
            </StyledButton>
          )}

          {shouldShowBulkActionButton() && (
            <div
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              className='af-display-navbar-bulk-wrap'
            >
              <Dropdown
                menu={{ items: menuItems }}
                placement='bottom'
                trigger={['click']}
                className='af-display-navbar-bulk-dropdown'
              >
                <StyledButton
                  type='primary'
                  className='create-button af-display-navbar-bulk-button'
                  onClick={() => dispatch(refreshToken())}
                >
                  Bulk Action
                </StyledButton>
              </Dropdown>
            </div>
          )}
          {shouldShowExportButton() && (
            <Tooltip title='Export' color='#597081' className='af-display-navbar-export-tooltip'>
              <StyledButton
                type='primary'
                onClick={handleExportClick}
                style={{ minWidth: 'unset', paddingTop: '6px' }}
                className='af-display-navbar-export-button'
              >
                <ExportIcon className='af-display-navbar-export-icon' />
              </StyledButton>
            </Tooltip>
          )}

          {bulkResetModal && (
            <Modal
              open={bulkResetModal}
              onCancel={() => setBulkResetModal(false)}
              maskClosable={false}
              footer={[null]}
              centered
              className='af-display-navbar-bulk-reset-modal'
            >
              <BulkResetPassword setBulkResetModal={setBulkResetModal} />
            </Modal>
          )}

          {bulkUpdateModal && (
            <Modal
              open={bulkUpdateModal}
              onCancel={() => setBulkUpdateModal(false)}
              maskClosable={false}
              footer={[null]}
              centered
              className='af-display-navbar-bulk-updateuser-modal'
            >
              <BulkUpdateUser setBulkUpdateModal={setBulkUpdateModal} />
            </Modal>
          )}

          {bulkCreateModal && (
            <Modal
              open={bulkCreateModal}
              onCancel={() => setBulkCreateModal(false)}
              maskClosable={false}
              footer={[null]}
              centered
              width={800}
              className='modal-style af-display-navbar-bulk-createuser-modal'
            >
              <BulkCreateUsers setBulkCreateModal={setBulkCreateModal} />
            </Modal>
          )}

          {isModalOpen && (
            <ImportUserModal
              footer={[null]}
              centered
              title='Import Users'
              open={isModalOpen}
              maskClosable={false}
              onCancel={handleCancel}
              className='af-display-navbar-import-modal'
            >
              <ImportUser
                handleCancel={handleCancel}
                setimportData={setimportData}
                importData={importData}
                fileName={fileName}
                setFileName={setFileName}
              />
            </ImportUserModal>
          )}
        </NavBarButtonWrap>
      </DisplayNavContent>
    </DisplayNavWrap>
  );
}
